export enum RegistrationStepsEnum {
  PASSPORT_STEP = 'PASSPORT_STEP',
  DRIVER_LICENSE_STEP = 'DRIVER_LICENSE_STEP',
  ADDITIONAL_DATA = 'ADDITIONAL_DATA',
  CORRECTION_STEP = 'CORRECTION_STEP',
  CONFIRM_CODE_STEP = 'CONFIRM_CODE_STEP',
  SUCCESS_STEP = 'SUCCESS_STEP',
  ERROR_STEP = 'ERROR_STEP',
}

export const stepsConfigs = Object.values(RegistrationStepsEnum)
export const firstStepConfig = stepsConfigs[0]

export const TIMER_REGISTRATION = 'timer_registration'
export const TIMER_REGISTRATION_TIME = 60000
